<a class="close" mat-dialog-close>&times;</a>
<h1 mat-dialog-title>Password reset request</h1>
<div class="dialog-content" mat-dialog-content>A password reset email was sent to your email address. If you don’t receive the email within few moments, please check your spam folder.</div>
<div mat-dialog-actions>
  <button class="close-button" mat-button mat-dialog-close>Close</button>
</div>
